const ERRORS = {
  FORBIDDEN: 'forbidden',
  RATE_LIMIT: 'rate_limit',
  NOT_FOUND: 'not_found',
  SERVICE_UNAVAILABLE: 'service_unavailable',
  VALIDATION: 'validation',
}

export default ERRORS
